import React from "react";
import CategoriesList from "./body/CategoriesList";
import Footer from "./footer/Footer";
import Contact from "./body/Contact";
import Navbar from "./navbar/Narbar";
import SearchBar from "./body/SearchBar";

const App = () => {
    return (
        <div>
            <div className="container">
                <Navbar/>
                <Contact/>
                <SearchBar/>
                <CategoriesList/>
            </div>
            <Footer/>
        </div>

    );
};

export default App;